import axios from 'axios'
import { camelizeKeys, decamelizeKeys } from 'humps'

import * as cookiesService from './cookies'

export function createRequestInstance(options) {
  const request = axios.create(options)

  request.interceptors.request.use((config) => {
    const token = cookiesService.getAccessToken()

    if (token) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${token}`,
      }
    }

    if (!(config.data instanceof FormData)) {
      config.data = decamelizeKeys(config.data)
    }
    return config
  })

  request.interceptors.response.use((response) => {
    response.data = camelizeKeys(response.data)
    return response
  })

  request.interceptors.response.use((response) => {
    response.data = camelizeKeys(response.data)
    return response
  })

  return request
}
